import React, { useState } from 'react';
import { useAppContext } from '../context/AppContext';
import logo from '../assets/logo.png';
import '../assets/login.css';
import { fetchToken } from '../services/fetchToken';


const LoginForm = () => {
    const { base_url, setToken } = useAppContext();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
        
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null); // Clear any previous errors
        fetchToken(email, password, base_url, setToken, setError);
    }

    return (
        <div className="login-container">
            <div className="logo-section dark-section">
                <img src={logo} alt="logo" />
                <p>Want to know how you can save hours every month on invoicing and revenue recognition by using Slipstream?</p>
                <a href="https://www.slipstreamautomations.com/" className="btn btn-secondary">Learn More</a>
            </div>
            <div className="login-section">
                {error && 
                <div id="alert-section" className="alert-section absolute-alert red-alert">
                    <h4>Alert</h4>
                    <p>{error}</p>
                </div>
                }
                <form onSubmit={handleSubmit} className="login-form">
                    <h1>Login to Slipstream</h1>
                    <input
                        placeholder="Email"
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <input
                        placeholder="Password"
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button className="btn btn-primary" type="submit">Login</button>
                </form>
            </div>
        </div>
    );
}

export default LoginForm;